import React from "react";
import styles from "./../../styles/__appointmentsDetails.module.scss";
import { MdOutlinePhone, MdOutlineCalendarMonth } from "react-icons/md";
import { PiChatCircleTextFill } from "react-icons/pi";
import { TbLocation } from "react-icons/tb";
import { GoClock } from "react-icons/go";
import { IoChevronDownSharp } from "react-icons/io5";
import IconJpg from "../../assets/images/jpgFile.svg";
import MapImg from "../../assets/images/appointmentHomeMap.png";
import { FaArrowLeft } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

const AppointmentDetails = ({
  homeVisit = false,
  selectedAppointment = { selectedAppointment },
  handleBack,
}) => {
  console.log("selectedAppointment:", selectedAppointment);

  const [mapError, setMapError] = React.useState(false);

  // Get location from appointment - check multiple possible paths
  const location = React.useMemo(() => {
    // Try different possible paths for latitude/longitude
    const lat =
      selectedAppointment?.latitude ||
      selectedAppointment?.raw?.latitude ||
      selectedAppointment?.raw?.patient?.latitude ||
      selectedAppointment?.raw?.onsite_details?.latitude ||
      selectedAppointment?.raw?.patient_address?.latitude ||
      null;

    const lng =
      selectedAppointment?.longitude ||
      selectedAppointment?.raw?.longitude ||
      selectedAppointment?.raw?.patient?.longitude ||
      selectedAppointment?.raw?.onsite_details?.longitude ||
      selectedAppointment?.raw?.patient_address?.longitude ||
      null;

    // Convert to numbers and use defaults if not available
    const latitude = lat ? parseFloat(lat) : 28.6139;
    const longitude = lng ? parseFloat(lng) : 77.209;

    return {
      lat: isNaN(latitude) ? 28.6139 : latitude,
      lng: isNaN(longitude) ? 77.209 : longitude,
    };
  }, [
    selectedAppointment?.latitude,
    selectedAppointment?.longitude,
    selectedAppointment?.raw?.latitude,
    selectedAppointment?.raw?.longitude,
    selectedAppointment?.raw?.patient?.latitude,
    selectedAppointment?.raw?.patient?.longitude,
    selectedAppointment?.raw?.onsite_details?.latitude,
    selectedAppointment?.raw?.onsite_details?.longitude,
  ]);

  const containerStyle = {
    width: "100%",
    height: "400px",
  };

  const navigate = useNavigate();

  const toHomeVisit = () => {
    navigate("/home-visit", {
      state: {
        appointment: selectedAppointment,
        from: "doctor-dashboard",
      },
    });
  };

  // Memoize API key to prevent re-initialization
  const apiKey = React.useMemo(
    () => process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
    [],
  );

  // Memoize loader options to prevent re-initialization with different options
  const loaderOptions = React.useMemo(
    () => ({
      googleMapsApiKey: apiKey,
      id: "google-map-script",
    }),
    [apiKey],
  );

  const { isLoaded } = useJsApiLoader(loaderOptions);

  // Set error if API key is missing
  React.useEffect(() => {
    if (!apiKey) {
      setMapError(true);
    }
  }, [apiKey]);

  return (
    <>
      <div className={styles["apt-appointments-section"]}>
        <div className={styles["apt-section-header"]}>
          <h2 className={styles["flexBox"]}>
            <FaArrowLeft onClick={handleBack} className={styles["backLink"]} />{" "}
            Appointments Details
          </h2>
          <div className={styles["apt-top-actions"]}>
            <button className={styles["btn-outlined-1"]}>Reschedule</button>
            {selectedAppointment?.location === "On-Site" ? (
              <button className={styles["btn-1"]} onClick={toHomeVisit}>
                Next
              </button>
            ) : (
              <button className={styles["btn-1"]}>Meet Now</button>
            )}
          </div>
        </div>

        {/* {selectedAppointment?.location == "On-Site" && (
          // <div className={styles["mapWrapper"]}>
          //   <img src={MapImg} alt="" />
          // </div>
           <LoadScript googleMapsApiKey="AIzaSyCI283tDlk7oxxhG5RazKph-fpi72obo9U11">
      {location?.lat && location?.lng && (
  <GoogleMap
    mapContainerStyle={containerStyle}
    center={location}
    zoom={14}
  >
    <Marker position={location} />
  </GoogleMap>
)}
    </LoadScript> */}
        {/* )} */}

        {selectedAppointment?.location === "On-Site" && (
          <div className={styles["mapWrapper"]}>
            {mapError || !process.env.REACT_APP_GOOGLE_MAPS_API_KEY ? (
              // Fallback to static image if map fails to load or API key is missing
              <>
                <img src={MapImg} alt="Location map" />
                <div
                  style={{
                    padding: "10px",
                    backgroundColor: "#fff3cd",
                    border: "1px solid #ffc107",
                    borderRadius: "4px",
                    marginTop: "10px",
                    fontSize: "14px",
                    color: "#856404",
                  }}
                >
                  Map unavailable. Please ensure Google Maps API key is
                  configured and billing is enabled.
                </div>
              </>
            ) : !isLoaded ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "400px",
                  backgroundColor: "#f5f5f5",
                }}
              >
                <p>Loading map...</p>
              </div>
            ) : (
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={location}
                zoom={14}
                options={{
                  disableDefaultUI: false,
                  zoomControl: true,
                }}
              >
                <Marker position={location} />
              </GoogleMap>
            )}
          </div>
        )}

        <div className={styles["patientDetails"]}>
          <div className={styles["patientInfoTop"]}>
            <div className={styles["patientProfile"]}>
              <div className={styles["patientTextInfo"]}>
                <h3>
                  {selectedAppointment?.name || "Rahul Rathi"}
                  <span className={styles["patientAge"]}>26 yr | M</span>
                </h3>
                <div className={styles["iconText-wrap"]}>
                  <span className={styles["icon"]}>
                    <MdOutlinePhone />
                  </span>
                  <span className={styles["text-gray"]}>
                    {selectedAppointment?.raw?.patient?.mobile_number ||
                      "(415) 555-8765"}
                  </span>
                </div>
              </div>
            </div>
            <button className={styles["chatBtn"]}>
              <PiChatCircleTextFill size={20} />
              <span className={styles["count"]}>1</span>
            </button>
          </div>

          {homeVisit && (
            <div className={styles["patientAddress"]}>
              <p className={styles["labelTxt"]}>Patient's Address</p>
              <div className={styles["iconText-wrap"]}>
                <span className={styles["icon"]}>
                  <TbLocation />
                </span>
                <span>
                  House No. 15, Street 4 Al-Mansour District 10013 Baghdad IRAQ
                </span>
              </div>
            </div>
          )}
          <div className={styles["flexCol"]}>
            <p className={styles["labelTxt"]}>Appointment Type</p>
            <div className={styles["onlineTag"]}>
              {homeVisit ? "Home Visit" : "Online Consultation"}
            </div>
          </div>
          <div className={styles["flexCol"]}>
            <p className={styles["labelTxt"]}>Appointment Date & Time</p>
            <div className={styles["flexBox"]}>
              <div className={styles["iconText-wrap"]}>
                <span className={styles["icon"]}>
                  <MdOutlineCalendarMonth />
                </span>
                <span>
                  {selectedAppointment?.raw?.appointment_date || "22/03/2025"}
                </span>
              </div>
              <div className={styles["iconText-wrap"]}>
                <span className={styles["icon"]}>
                  <GoClock />
                </span>
                <span>
                  {selectedAppointment?.time ||
                    selectedAppointment?.raw?.appointment_time ||
                    "22:30"}
                </span>
              </div>
            </div>
          </div>

          {homeVisit && (
            <div className={styles["caseNote"]}>
              <p className={styles["labelTxt"]}>CASE NOTE</p>
              <p>
                My current symptoms related to this are persistent fatigue and
                unexplained joint pain that started two weeks ago.
              </p>
            </div>
          )}
        </div>

        <div className={styles["medical-history"]}>
          <div className={styles["section-title"]}>Medical History</div>

          <div className={styles["history-grid"]}>
            <div className={styles["field-block"]}>
              <div className={styles["label"]}>Chief Complaint</div>
              <div className={styles["value"]}>
                Severe chest pain and difficulty breathing.
              </div>
            </div>
          </div>

          <div className={`${styles["history-grid"]} ${styles["med-grid"]}`}>
            <div className={styles["field-block"]}>
              <div className={styles["label"]}>Medical History</div>
              <div className={styles["value"]}>
                Hypertension, Type 2 Diabetes
              </div>
            </div>

            <div className={styles["field-block"]}>
              <div className={styles["label"]}>Surgical History</div>
              <div className={styles["value"]}>Appendectomy (2005)</div>
            </div>

            <div className={styles["field-block"]}>
              <div className={styles["label"]}>Allergies</div>
              <div className={styles["value"]}>Penicillin (Rash)</div>
            </div>

            <div className={styles["field-block"]}>
              <div className={styles["label"]}>Medication History</div>
              <div className={styles["value"]}>
                Metformin 500mg, Lisinopril 10mg
              </div>
              <div className={styles["attachment-btn"]}>
                <div className={styles["iconBox"]}>
                  <img src={IconJpg} alt="jpg file" />
                </div>
                Prescription
              </div>
            </div>

            <div className={styles["field-block"]}>
              <div className={styles["label"]}>
                Previous Tests & Investigations
              </div>
              <div className={styles["value"]}>CBC</div>
              <div className={styles["attachment-btn"]}>
                <div className={styles["iconBox"]}>
                  <img src={IconJpg} alt="jpg file" />
                </div>
                Report
              </div>
            </div>
          </div>

          <div className={styles["section-title"]}>Social History</div>

          <div className={styles["history-grid"]}>
            <div className={styles["field-block"]}>
              <div className={styles["label"]}>Smoking</div>
              <div className={styles["value"]}>Former</div>
            </div>

            <div className={styles["field-block"]}>
              <div className={styles["label"]}>Alcohol</div>
              <div className={styles["value"]}>Occasional</div>
            </div>

            <div className={styles["field-block"]}>
              <div className={styles["label"]}>Caffeine Intake</div>
              <div className={styles["value"]}>Low</div>
            </div>

            <div className={styles["field-block"]}>
              <div className={styles["label"]}>Exercise Habits</div>
              <div className={styles["value"]}>None</div>
            </div>
          </div>

          <div
            className={`${styles["field-block"]} ${styles["mb-24"]} ${styles["full-width"]}`}
          >
            <div className={styles["label"]}>Family History</div>
            <div className={styles["value"]}>
              Father: MI at 55. Mother: Breast Cancer survivor.
            </div>
          </div>

          <div className={styles["sub-section-title"]}>Document Upload</div>

          <div className={styles["upload-row"]}>
            <div className={styles["upload-item"]}>
              <div className={styles["iconBox"]}>
                <img src={IconJpg} alt="jpg file" />
              </div>
              Medical Document
            </div>
            <div className={styles["upload-item"]}>
              <div className={styles["iconBox"]}>
                <img src={IconJpg} alt="jpg file" />
              </div>
              Medical Document
            </div>
            <div className={styles["upload-item"]}>
              <div className={styles["iconBox"]}>
                <img src={IconJpg} alt="jpg file" />
              </div>
              Medical Document
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppointmentDetails;
